import axios from 'axios';
import { PagePerplexity } from '../../types/perplexity';

export const getPagePerplexity = async (
  minPerplexity?: number,
  maxPerplexity?: number,
  count?: number
) => {
  return await axios
    .get<PagePerplexity[]>(
      `${process.env.REACT_APP_BACKEND_URL}/samples/page-perplexity`,
      {
        params: {
          minPerplexity,
          maxPerplexity,
          count,
        },
      }
    )
    .then((response) => {
      return response.data;
    });
};
